import { BankRegistrationGuide } from './BankRegistrationGuide';
import {
  NONGHYUP_COMPLETE_REGISTRATION_STEPS,
  NONGHYUP_NOTIFY_OPTIONS,
  NONGHYUP_REQUEST_CODE_STEPS,
} from './nonghyupGuide';
import { GATEWAY_NUMBER_DISPLAY } from './wooriGuide';

interface Props {
  authCode: string | null;
  codeRemainingSec: number | null;
  registered: boolean;
  onCancel: () => void;
  onComplete: () => void;
}

export function NonghyupRegistrationGuide(props: Props) {
  return (
    <BankRegistrationGuide
      {...props}
      bankAppLabel="농협은행 앱"
      authCodeLength={6}
      requestCodeSteps={NONGHYUP_REQUEST_CODE_STEPS}
      completeRegistrationSteps={NONGHYUP_COMPLETE_REGISTRATION_STEPS}
      notifyOptions={NONGHYUP_NOTIFY_OPTIONS}
      awaitingCodeMessage="5단계에서 [인증번호 발송]을 누르면 이곳에 자동으로 표시돼요."
      gatewayNumber={GATEWAY_NUMBER_DISPLAY}
    />
  );
}
